import { render, staticRenderFns } from "./NewsCardPage.vue?vue&type=template&id=6dc95537&"
import script from "./NewsCardPage.vue?vue&type=script&lang=js&"
export * from "./NewsCardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports